import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-resumes-supplementary-answers',
  templateUrl: './resumes-supplementary-answers.component.html',
  styleUrls: ['./resumes-supplementary-answers.component.scss']
})
export class ResumesSupplementaryAnswersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
